<template>
    <span class="processNode" :style="{'width':flowType<3?'240px':'128px'}">
      <!--flowType是1或2时，有下载证书，3时没有下载证书-->
      <!--由于现在暖通也是要下载证书的，所有直接所有flowType都传入1了-->
      <span class="processNode__bar">
        <span class="line"></span>
        <span class="point point1 pass"></span>
        <span class="point point2" :style="{'left':flowType<3?'0':'auto'}" :class="{'active':flowStatus<=1 || flowType>=3,'pass':flowStatus>=2,'reject':flowStatus==0}"></span>
        <span class="point point3 last" :class="{'active':flowStatus===2,'pass':flowStatus>=2}" v-if="flowType<3"></span>
        <span class="process-line"  :style="{'width':processLineWdith}" :class="{'reject':flowStatus==0}" ></span>
      </span>
      <span class="processNode__tips">
        <span class="label">提交验证</span>
        <span class="label" :style="{'left':flowType<3?'0':'auto','margin-right':flowType<3?'0':'-6px'}">{{secondLabel}}</span>
        <span class="label last" v-if="flowType<3"  :class="{'active':flowStatus>=2}" :style="{'cursor':flowStatus>=2?'pointer':''}" @click="downloadLicense">下载证书</span>
      </span>
    </span>
</template>

<script>
  import qs from 'qs'
  import {exportMethod} from '@/utils/fileExports'
  export default {
    name: "processNode",
    props:{
      flowStatus:{
        type:Number,
        default:1
      },
      flowType:{
        type:Number,
        default:1
      },
      downCode:{
        type:String,
        default:''
      },
      registerId:{
        type:String,
        default:''
      },
    },
    computed:{
      secondLabel(){
        if(this.flowStatus === 0){
          return '驳回'
        }
        return '验证通过'
      },
      processLineWdith(){
        if(this.flowStatus==0){
          if(this.flowType<=2){
            return '50%'
          }
        }
        return this.flowStatus==1?'0':'100%'
      }
    },
    methods:{
      downloadLicense(){
        if(this.flowStatus !==2){
          return ;
        }
        let myObj = {
          method: 'get',
          url: 'api/product/downloadLicense',
          params: qs.stringify({
            registerId:this.registerId,
            productSerialNumber:this.downCode
          })
        };
        exportMethod(myObj);
      }
    }
  }
</script>

<style scoped lang="less">
  .processNode {
    display: inline-block;

    &__bar, &__tips {
      display: inline-block;
      width: 100%;
    }
    &__bar {
      position: relative;
      .line {
        display: inline-block;
        height: 8px;
        background-color: #D4D7DC;
        width: 100%;
        border-radius: 8px;
      }
      .point {
        display: inline-block;
        position: absolute;
        height: 8px;
        width: 8px;
        border-radius: 100%;
        background: #95989d;
        margin: auto;
        top: 0;
        bottom:0;
        z-index: 2;
      }
      .point.pass {
        background-color: #5c89e5;
      }
      /* 点变大 */
      .point.active {
        width: 14px;
        height: 14px;
      }
      .point1 {
        left: 0;
        top: 0;
      }
      .point2 {
        left: 0;
        right: 0;
      }
      /* 点变红 */
      .point.reject{
        background-color: #e81a42;
      }
      .point3 {
        right: 0;
        top: 0;
      }
      .process-line{
        display: inline-block;
        position: absolute;
        height: 8px;
        border-radius: 8px;
        background: #afcdff;
        margin: auto;
        top: 0;
        bottom:0;
        width:100%;
        left: 0;
        z-index: 1;
      }
      /* 线变红 */
      .process-line.reject{
        background-color: #ffb3d7;
      }
    }

    &__tips{
      position: relative;
      height: 16px;
      span.label{
        display: inline-block;
        text-align: center;
        position: absolute;
        top: 0;
        bottom: 0;
        margin: auto;
        left: 0;
        right: 0;
        &:first-child{
          text-align: left;
          right: auto;
        }
        &.last{
          text-align: right;
          left: auto;
          border-bottom: 2px solid;
          padding-bottom: 19px;
        }
        &.last.active{
          color: #5c89e5;
        }
      }
    }
  }
</style>
